import angular from 'angular';
import moment from 'moment';
import './webModulesServices';
import 'angular-bootstrap';
import 'ui-select';
import 'ng-flow';
import 'angular-bootstrap-colorpicker/js/bootstrap-colorpicker-module';
import 'angular-bootstrap-colorpicker/css/colorpicker.css';

const controllers = angular.module('applicationModule.webModulesControllers', [
    'applicationModule.webModulesServices',
    'colorpicker.module',
    'flow',
    'ui.bootstrap',
    'ui.select'
]);

controllers.controller('WebModuleModalController', [
    '$scope',
    '$state',
    '$stateParams',
    '$modalInstance',
    'Webmodules',
    'growl',
    'module',
    'params',
    '$modal',
    '$filter',
    function (
        $scope,
        $state,
        $stateParams,
        $modalInstance,
        Webmodules,
        growl,
        module,
        params,
        $modal,
        $filter
    ) {
        'use strict';

        const pluck = (array, key) => array.map(obj => obj[key]);

        const appId = $stateParams.application_id;
        $scope.module = {
            page_id: module.page_id,
            container: module.container,
            application_id: appId,
            template: null,
            view_template: null,
            id: null,
            draft: {}
        };
        $scope.lang = $filter('translate')('LANG');

        $scope.upload = {};
        $scope.fileUploaded = {};
        $scope.fileName = {};
        $scope.invalidContractor = undefined;

        $scope.isDatepickerOpen = {};

        $scope.closeCalendar = key => {
            $scope.isDatepickerOpen[key] = false;
        };

        $scope.beforeRenderCalendar = (key, $view, $dates) => {
            if ($scope.module.draft) {
                const draft = $scope.module.draft;
                let activeDate;

                if (key === 'dateFrom' && draft.dateTo) {
                    activeDate = moment(draft.dateTo);

                    $dates.forEach(date => {
                        if (date.localDateValue() >= activeDate.valueOf()) {
                            date.selectable = false;
                        }
                    });
                }

                if (key === 'dateTo' && draft.dateFrom) {
                    activeDate = moment(draft.dateFrom).subtract(1, $view).add(1, 'minute');

                    $dates.forEach(date => {
                        if (date.localDateValue() <= activeDate.valueOf()) {
                            date.selectable = false;
                        }
                    });
                }
            }
        };

        $scope.showCopy = true;

        $scope.errors = {};
        $scope.inputs = [];

        if (module.name) {
            $scope.editMode = true;
            $scope.module = angular.copy(module);
        }

        $scope.autocomplete = (text, key, filter) => {
            $scope.values = [];
            if (angular.isDefined(filter)) {
                text = $filter(filter)(text);
            }
            text = encodeURIComponent(text);
            if ($scope.module.template == 54) {
                $scope.existingAuthorsIds = pluck($scope.module.draft.recipes_authors, 'external_id');
            }

            if (/^\d+$/.test(text)) {
                text = parseInt(text);
            }
            if (text.length === 0 || text.length >= 3 || typeof text == 'number') {
                Webmodules.autocomplete($scope.module.application_id, $scope.module.template, text).then(function (response) {
                    var data = response.data;
                    if (data.success) {
                        if (data.values[key]) {
                            $scope.values = data.values[key];
                        } else {
                            $scope.values = data.values;
                        }
                    }
                });
            }
        };

        $scope.values = [];

        $scope.tinymceOptions = angular.getTinymceOptions($modal);

        if (angular.isDefined($scope.lang) && $scope.lang !== 'en') {
            $scope.tinymceOptions.language = $scope.lang;
            $scope.tinymceOptions.languageUrl = `/assets/tinymce/${$scope.lang}.js`;
        }

        params.application_id = appId;
        params.template = $scope.module.template;
        params.module_id = $scope.module.id;

        $scope.isLoading = true;

        $scope.change_template = function () {
            $scope.isLoading2 = true;
            params.template = $scope.module.template;
            Webmodules.create(params).then(response => {
                $scope.data = response;
                $scope.inputs = response.inputs;
                $scope.templateName = response.templateName;

                $scope.showCopy = $scope.templateName !== 'Button';

                $scope.inputs.forEach(val => {
                    if (val.type === 'ng-wig' && !$scope.module.draft[val.key]) {
                        $scope.module.draft[val.key] = '';
                    }
                    if (val.type === 'checkbox') {
                        if (angular.isDefined($scope.module.draft[val.key])) {
                            $scope.module.draft[val.key] = $scope.module.draft[val.key] === 1 || $scope.module.draft[val.key] === '1';
                        }
                    }
                    if (val.type === 'number' && $scope.module.draft[val.key]) {
                        $scope.module.draft[val.key] = Number($scope.module.draft[val.key]);
                    }
                    if (val.type === 'file' && $scope.module.draft[val.key]) {
                        $scope.fileName[val.key] = $scope.module.draft[val.key];
                        $scope.fileUploaded[val.key] = true;
                    }
                    if (val.type === 'file-csv') {
                        if (angular.isDefined($scope.module.draft[val.key]) && $scope.module.draft[val.key]) {
                            $scope.fileUploaded[val.key] = true;
                            $scope.fileName[val.key] = $scope.module.draft[val.key]['file_name'];
                        } else {
                            $scope.upload[val.key] = undefined;
                            $scope.fileUploaded[val.key] = false;
                        }
                    }
                    if (val.default && !$scope.module.draft[val.key]) {
                        $scope.module.draft[val.key] = val.default;
                    }
                });
            }).finally(() => {
                $scope.isLoading = false;
                $scope.isLoading2 = false;
            });
        };
        $scope.change_template();

        $scope.change_tab = function () {
            $scope.module.first_tab = false;
            if ($scope.module.tab == $scope.data.tab_list[0]) {
                $scope.module.first_tab = true;
            }
        };

        $scope.checkValid = function (name) {
            return angular.isDefinedNotNull($scope.errors[name]);
        };

        $scope.toDisable = function (element) {
            var disable = false;
            if (element) {
                angular.forEach(element, function (v) {
                    if (angular.isDefined($scope.module.draft)) {
                        if (angular.isDefined($scope.module.draft[v])) {
                            if ($scope.module.draft[v].length > 0) {
                                disable = true;
                            }
                        }
                    }
                });
            }

            return disable;
        };

        $scope.removeFile = key => {
            delete $scope.upload[key];
            $scope.invalidContractor = undefined;
            if (angular.isDefined($scope.module.draft[key])) {
                delete $scope.module.draft[key];
            }
            $scope.fileUploaded[key] = false;
            $scope.fileName[key] = undefined;
        };

        $scope.uploadSuccess = (file, key) => {
            $scope.upload[key] = file;
            $scope.fileUploaded[key] = true;
            $scope.fileName[key] = undefined;
            $scope.$apply();
        };

        $scope.ok = () => {
            $scope.$broadcast('show-errors-check-validity');
            $scope.pageForm.template.$touched = true;
            if ($scope.pageForm.$valid) {
                $scope.isLoading = true;

                angular.forEach($scope.inputs, function (val) {
                    if (angular.isDefined(val.filter)) {
                        var tmp = [];
                        angular.forEach($scope.module.draft[val.key], function (v) {
                            tmp.push($filter(val.filter)(v));
                        });
                        $scope.module.draft[val.key] = tmp;
                    }
                    if (val.default && !$scope.module.draft[val.key]) {
                        $scope.module.draft[val.key] = 0;
                    }
                });

                $scope.module.draft = angular.copy($scope.module.draft); // usuwa $$hasKey z draft
                Webmodules.save($scope.module, $scope.upload, $scope.editMode)
                    .then(result => {

                        let data = result.data;
                        if (data.success) {
                            $modalInstance.close(data);
                        } else {
                            if (typeof data.error === 'object') {
                                $scope.formErrors = data.error;
                            } else {
                                growl.error('MODULES.APPLICATIONS.MODULES.WWW.MODULES.ERROR.CREATED');
                            }
                        }
                    })
                    .finally(() => {
                        $scope.isLoading = false;
                    });
            }
        };

        $scope.cancel = () => {
            $modalInstance.dismiss('cancel');
        };

        $scope.remove = () => {
            $modalInstance.dismiss('cancel');
        };

        $scope.inputErrors = {
            'name': [{type: '$invalid', msg: 'ERROR.REQUIRE.NAME'}],
            'template': [{type: '$invalid', msg: 'ERROR.REQUIRE.TEMPLATE'}]
        };

        $scope.filterExisting = author => !$scope.existingAuthorsIds.includes(author.externalId);
    }]);

controllers.controller('AddWebModuleModalController', [
        '$scope',
        '$state',
        '$stateParams',
        '$modalInstance',
        'Webmodules',
        'growl',
        'module',
    (
        $scope,
        $state,
        $stateParams,
        $modalInstance,
        Webmodules,
        growl,
        module
    ) => {
        'use strict';

        const appId = $stateParams.application_id;

        $scope.module = {
            id: module.id,
            name: module.name,
            application_id: appId,
            page_id: module.page_id
        };

        $scope.showCopy = true;

        Webmodules.containers($stateParams.application_id, module.page_id)
            .then(function (response) {
                $scope.containers = response;
            });

        $scope.ok = () => {
            $scope.$broadcast('show-errors-check-validity');
            $scope.pageForm.container.$touched = true;
            if ($scope.pageForm.$valid) {
                $scope.isLoading = true;
                Webmodules.add($scope.module, $scope.upload)
                    .then(result => {
                        let data = result.data;

                        if (data.success) {
                            $modalInstance.close(data.module);
                        } else {
                            if (typeof data.error === 'object') {
                                $scope.formErrors = data.error;
                            } else {
                                growl.error('MODULES.APPLICATIONS.MODULES.WWW.MODULES.ERROR.CREATED');
                            }
                        }
                    })
                    .finally(() => {
                        $scope.isLoading = false;
                    });
            }
        };

        $scope.cancel = () => {
            $modalInstance.dismiss('cancel');
        };

        $scope.inputErrors = {
            name: [{type: '$invalid', msg: 'ERROR.REQUIRE.NAME'}],
            template: [{type: '$invalid', msg: 'ERROR.REQUIRE.TEMPLATE'}],
            container: [{type: '$invalid', msg: 'ERROR.REQUIRE.CONTAINER'}]
        };
    }]);

export default controllers;
